import { useEffect } from 'react'

import mixpanel from 'mixpanel-browser'
import { useLocation } from 'react-router-dom'

export const PageViewHandler = () => {
  const location = useLocation()

  const logPageView = () => {
    mixpanel.track('Page View', {
      path: location.pathname,
      search: location.search,
    })
  }

  useEffect(() => {
    logPageView()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: logPageView intentionally omitted to prevent infinite loops - should only run on location change
  }, [location])
  return <> </>
}
